import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from './contexts/ThemeContext';
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Ensure the initial theme class is set on the HTML element before rendering
const root = ReactDOM.createRoot(document.getElementById('root'));

// Initial theme setup
const savedTheme = localStorage.getItem('theme');
const isDarkMode = savedTheme === 'dark' || 
  (!savedTheme && window.matchMedia('(prefers-color-scheme: dark)').matches);

if (isDarkMode) {
  document.documentElement.classList.add('dark');
} else {
  document.documentElement.classList.remove('dark');
}

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
